import {Component, OnInit} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {NbDialogRef} from '@nebular/theme';
import {Router} from '@angular/router';

@Component({
  selector: 'app-simple-message-dialog',
  templateUrl: './simple-message-dialog.component.html',
  styleUrls: ['./simple-message-dialog.component.css']
})
export class SimpleMessageDialogComponent extends BaseDialog<SimpleMessageDialogComponent> implements OnInit {
  title: string;
  msg: string;

  constructor(dialogRef: NbDialogRef<SimpleMessageDialogComponent>, route: Router) {
    super(dialogRef, route);
  }

  ngOnInit() {
  }

}
